<template>
  <div>
    <div class="navbar-container">
      <navtop></navtop>
      <navbottom></navbottom>
    </div>
    <div class="empty"></div>
  </div>
</template>
<script>
import navtop from "./navbar/navtop";
import navbottom from "./navbar/navbottom";
export default {
  components: {
    navtop,
    navbottom
  }
};
</script>
<style lang="scss" scoped>
.navbar-container {
  width: 100%;
  background: #fff;
  // position: fixed;
  top: 0;
  // z-index:999;
}
.empty {
  // height: 160px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue